export default __webpack_public_path__ + "static/media/darkmeditation.38a01fd3.png";